import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Download, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";

export default function SupportAttachmentPage() {
  const { ticketId, fileId } = useParams();
  const { user } = useAuth();
  const basePath = user?.role === "superadmin" ? "/admin/assistenza" : "/assistenza";
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    let objectUrl = "";
    const controller = new AbortController();
    setLoading(true); setError(""); setFile(null); setUrl("");
    const load = async () => {
      try {
        const { data: ticket } = await api.get(`/support/tickets/${ticketId}`, { signal: controller.signal });
        const attachment = ticket.messages.flatMap(message => message.attachments || [])
          .find(item => item.id === fileId);
        if (!attachment) throw new Error("Allegato non disponibile.");
        const { data } = await api.get(`/support/tickets/${ticketId}/attachments/${fileId}`,
                                       { responseType: "blob", signal: controller.signal });
        if (!active) return;
        objectUrl = URL.createObjectURL(new Blob([data], { type: attachment.mime_type }));
        setFile(attachment); setUrl(objectUrl);
      } catch {
        if (active) setError("Allegato non disponibile o accesso non consentito.");
      } finally { if (active) setLoading(false); }
    };
    load();
    return () => { active = false; controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [ticketId, fileId]);

  return <div className="max-w-6xl mx-auto px-4 sm:px-8 pt-8 pb-16 min-w-0" data-testid="support-attachment-page">
    <header className="flex flex-wrap items-start justify-between gap-4 mb-7">
      <div className="min-w-0">
        <Link to={`${basePath}/${ticketId}`} className="inline-flex items-center gap-2 text-sm text-[#707070] hover:text-[#1A1A1A] mb-5"
              data-testid="support-attachment-back"><ArrowLeft className="w-4 h-4" />Torna al ticket</Link>
        <h1 className="font-serif text-4xl sm:text-5xl break-words" data-testid="support-attachment-name">
          {file?.name || "Allegato"}
        </h1>
      </div>
      {url && <a href={url} download={file.name} className="btn-primary inline-flex items-center gap-2"
                 data-testid="support-attachment-download"><Download className="w-4 h-4" />Scarica</a>}
    </header>
    {loading && <p className="flex items-center gap-2 text-sm text-[#707070]" data-testid="support-attachment-loading">
      <Loader2 className="w-4 h-4 animate-spin" />Caricamento allegato...
    </p>}
    {error && <p role="alert" className="text-sm text-[#8C3A3A]" data-testid="support-attachment-page-error">{error}</p>}
    {url && file?.mime_type.startsWith("image/") && <div className="bg-[#EDEDE9] min-h-[40vh] flex items-center justify-center p-3 sm:p-8">
      <img src={url} alt={file.name} className="max-w-full max-h-[78vh] object-contain"
           data-testid="support-attachment-full-image" />
    </div>}
    {url && file?.mime_type === "application/pdf" && <iframe src={url} title={file.name}
      className="w-full h-[75vh] bg-white border border-[#E4E3DE]" data-testid="support-attachment-full-pdf" />}
  </div>;
}